export default "<ontology-table *ngFor=\"let dataMapping of dataMappings\" [dataMapping]=\"dataMapping | uniqueEntry\"></ontology-table>\n"